import { useState, useEffect } from 'react';
import { GewichtsHistorie, apiFetch } from './shared';

const API = '/api';

function localDate(d = new Date()) {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

function buildKalender(gymTage, stravaTage, atemschutzTage, wochen = 6) {
  const gymMap = {};
  gymTage.forEach(g => { gymMap[g.datum] = g.gruppe; });
  const stravaMap = {};
  stravaTage.forEach(s => { stravaMap[s.datum] = parseFloat(s.km); });
  const atemschutzSet = new Set((atemschutzTage || []).map(a => a.datum));
  const today = new Date();
  const todayStr = localDate(today);
  const dow = (today.getDay() + 6) % 7;
  const mon = new Date(today);
  mon.setDate(today.getDate() - dow);
  mon.setHours(12, 0, 0, 0);
  const weeks = [];
  for (let w = wochen - 1; w >= 0; w--) {
    const days = [];
    let weekKm = 0;
    for (let d = 0; d < 7; d++) {
      const dt = new Date(mon);
      dt.setDate(mon.getDate() - w * 7 + d);
      const s = localDate(dt);
      const km = stravaMap[s] || 0;
      weekKm += km;
      days.push({ s, day: dt.getDate(), month: dt.getMonth() + 1, gym: gymMap[s] || null, km: km || null, atemschutz: atemschutzSet.has(s), today: s === todayStr, future: s > todayStr });
    }
    weeks.push({ days, weekKm: Math.round(weekKm * 10) / 10 });
  }
  return weeks;
}

export default function VerlaufAnsicht({ onClose }) {
  const [kal, setKal] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [gew, setGew] = useState(null);

  useEffect(() => {
    apiFetch(API + '/dashboard/kalender').then(r => r.json()).then(setKal).catch(() => {});
    apiFetch(API + '/kraft/sessions').then(r => r.json()).then(setSessions).catch(() => {});
    apiFetch(API + '/kraft/gewichts-verlauf').then(r => r.json()).then(setGew).catch(() => {});
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#e0e0e0' }}>Verlauf</div>
        <button onClick={onClose} style={{ background: 'transparent', border: '1px solid #2a2a2a', borderRadius: 6, color: '#666', fontSize: 12, padding: '4px 12px', cursor: 'pointer', fontFamily: 'inherit' }}>Zurück</button>
      </div>

      {/* Kalender */}
      {!kal ? (
        <div style={{ color: '#444', fontSize: 12, padding: 8 }}>Lade...</div>
      ) : (() => {
        const wochen = buildKalender(kal.gymTage, kal.stravaTage, kal.atemschutzTage);
        const MONATE = ['', 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
        const MONAT_FARBEN = ['#4a7a9a', '#9a7a4a', '#4a8a6a', '#8a6a9a', '#9a4a4a', '#6a8a4a', '#4a6a8a', '#8a4a6a', '#7a9a4a', '#4a9a7a', '#9a4a7a', '#7a4a9a'];
        return (
          <div style={{ background: '#141414', borderRadius: 8, overflow: 'hidden' }}>
            <div style={{ padding: '10px 14px', background: '#1c1c1c', borderBottom: '1px solid #222', fontSize: 12, color: '#888' }}>Letzte 6 Wochen</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr) 38px', gap: 2, padding: '6px 10px 2px' }}>
              {['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(d => (
                <div key={d} style={{ fontSize: 9, color: '#444', textAlign: 'center', letterSpacing: 0.5 }}>{d}</div>
              ))}
              <div />
            </div>
            {wochen.flatMap((week, wi) => {
              const curMonth = week.days[0]?.month;
              const prevMonth = wi > 0 ? wochen[wi - 1].days[0]?.month : null;
              const farbe = MONAT_FARBEN[(curMonth - 1) % MONAT_FARBEN.length];
              const rows = [];
              if (wi === 0 || prevMonth !== curMonth) {
                rows.push(
                  <div key={`sep${wi}`} style={{ padding: '5px 10px 2px', fontSize: 9, fontWeight: 700, letterSpacing: 1.5, color: farbe, borderTop: wi > 0 ? '1px solid #1e1e1e' : 'none', marginTop: wi > 0 ? 2 : 0 }}>
                    {MONATE[curMonth].toUpperCase()}
                  </div>
                );
              }
              rows.push(
                <div key={wi} style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr) 38px', gap: 2, padding: '2px 10px', alignItems: 'center' }}>
                  {week.days.map((day, di) => (
                    <div key={di} style={{
                      background: day.future ? 'transparent' : day.gym && day.atemschutz ? '#0d1a10' : day.gym ? '#0d2010' : day.atemschutz ? '#1a1000' : day.km ? '#090d1f' : '#181818',
                      borderRadius: 4,
                      border: `1px solid ${day.today ? '#4a9c6f' : day.atemschutz ? '#5a3a10' : day.gym ? '#1c3d1c' : day.km ? '#151f3a' : 'transparent'}`,
                      minHeight: 42, padding: '3px 2px',
                      display: 'flex', flexDirection: 'column', alignItems: 'center',
                      opacity: day.future ? 0.2 : 1,
                    }}>
                      <div style={{ fontSize: 9, color: day.today ? '#4a9c6f' : '#3a3a3a', lineHeight: 1.6 }}>{day.day}</div>
                      {day.gym && <div style={{ fontSize: 12, fontWeight: 700, color: '#5abf7a', lineHeight: 1.1 }}>G</div>}
                      {day.atemschutz && <div style={{ fontSize: 11, fontWeight: 700, color: '#c17f24', lineHeight: 1.1 }}>A</div>}
                      {day.km && <div style={{ fontSize: 9, color: '#5a8fd4', lineHeight: 1.3, marginTop: day.gym || day.atemschutz ? 1 : 'auto' }}>{day.km}</div>}
                    </div>
                  ))}
                  <div style={{ fontSize: 11, fontWeight: 700, color: week.weekKm >= 100 ? '#4a9c6f' : week.weekKm > 0 ? '#5a8fd4' : '#252525', textAlign: 'right', paddingRight: 2 }}>
                    {week.weekKm > 0 ? week.weekKm : ''}
                  </div>
                </div>
              );
              return rows;
            })}
            <div style={{ padding: '6px 12px', borderTop: '1px solid #1c1c1c', display: 'flex', gap: 14, fontSize: 10 }}>
              <span style={{ color: '#5abf7a' }}>■ <span style={{ color: '#444' }}>Gym</span></span>
              <span style={{ color: '#c17f24' }}>■ <span style={{ color: '#444' }}>Atemschutz</span></span>
              <span style={{ color: '#5a8fd4' }}>■ <span style={{ color: '#444' }}>km Rad</span></span>
            </div>
          </div>
        );
      })()}

      {/* Gewichtshistorie */}
      <GewichtsHistorie verlaufGew={gew} />

      {/* Letzte Gym-Sessions */}
      {sessions.length > 0 && (
        <div style={{ background: '#141414', borderRadius: 8, overflow: 'hidden' }}>
          <div style={{ padding: '10px 14px', background: '#1c1c1c', borderBottom: '1px solid #222', fontSize: 12, color: '#888' }}>Letzte Gym-Sessions</div>
          {sessions.map((s, i) => (
            <div key={i} style={{ padding: '11px 14px', borderBottom: '1px solid #1a1a1a', display: 'grid', gridTemplateColumns: 'auto auto 1fr', gap: 10, alignItems: 'start' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: s.gruppe === 'gym_a' ? '#5abf7a' : s.gruppe === 'gym_c' ? '#c19a3a' : '#5a8fd4', background: '#1c1c1c', borderRadius: 4, padding: '2px 7px', whiteSpace: 'nowrap' }}>
                {s.gruppe === 'gym_a' ? 'UK' : s.gruppe === 'gym_c' ? 'Ganzkörper / Essentials' : 'OK'}
              </div>
              <div style={{ fontSize: 11, color: '#555', whiteSpace: 'nowrap', paddingTop: 2 }}>
                {new Date(s.datum).toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Berlin' })}
              </div>
              <div style={{ fontSize: 11, color: '#444', lineHeight: 1.6 }}>
                {(s.uebungen || '').split(',').join(' · ')}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
